module.exports = __webpack_public_path__ + "img/ysns.59552da6.jpg";